class Equalize {
  setEventHandler() {
    const equalizerRun = () => {
      new Equalize().run();
    };

    ['load', 'resize'].forEach((event) => {
      window.addEventListener(event, equalizerRun);
    });

    document.addEventListener('ready', equalizerRun);
  }

  nodeListChildren(elements, querySelector) {
    const children = [];
    elements.forEach((el) => {
      children.concat(Array.from(el.querySelectorAll(querySelector)));
    });

    return children;
  }

  nodeListSetStyleProperty(elements, property, value) {
    elements.forEach((el) => {
      el.style.setProperty(property, value);
    });
  }

  nodeListRemoveStyleProperty(elements, property) {
    elements.forEach((el) => {
      el.style.removeProperty(property);
    });
  }

  nodeListFilterByClass(elements, className) {
    return [...elements].filter((el) => el.classList.contains(className));
  }

  nodeListFilterByMissingClass(elements, className) {
    return [...elements].filter((el) => !el.classList.contains(className));
  }

  nodeListFilterByDataEqAttribute(elements, attribute, value = null) {
    if (value === null) {
      return [...elements].filter((el) => el.dataset.hasOwnProperty(attribute));
    }

    return [...elements].filter((el) => el.dataset.hasOwnProperty(attribute) && el.dataset[attribute] === value);
  }

  getRowElements(top, elements) {
    return [...elements].filter((el) => {
      const rect = el.getBoundingClientRect();

      return (rect.top >= top - 16 && rect.top <= top + 16);
    });
  }

  elementIsVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  equalize(rowElements) {
    const rowElementsEqParts = this.nodeListFilterByDataEqAttribute(rowElements, 'eqPart');
    const rowElementsEqPartGroups = this.nodeListFilterByDataEqAttribute(rowElements, 'eqPartGroup');

    if (rowElementsEqParts.length) {
      const eqPartKeys = [];
      rowElementsEqParts.forEach((el) => {
        const { eqPart } = el.dataset;

        if (eqPartKeys.indexOf(eqPart) === -1) {
          eqPartKeys.push(eqPart);
        }
      });

      const eqPartGroups = [];
      rowElementsEqPartGroups.forEach((el) => {
        const eqGroup = el.dataset.eqPartGroup;
        if (eqPartGroups.indexOf(eqGroup) === -1) {
          eqPartGroups.push(eqGroup);
        }
      });

      eqPartKeys.forEach((partKey) => {
        let minHeight = 0;
        const eqPartElements = this.nodeListFilterByDataEqAttribute(rowElements, 'eqPart', partKey);

        eqPartElements.forEach((el) => {
          const elHeight = el.clientHeight;
          if (elHeight > minHeight) {
            minHeight = elHeight;
          }
        });

        this.nodeListSetStyleProperty(eqPartElements, 'min-height', `${minHeight}px`);
      });

      eqPartGroups.forEach((group) => {
        const groupKeys = group.split(',');
        let minHeight = 0;

        groupKeys.forEach((groupKey) => {
          const eqPartGroupElements = this.nodeListFilterByDataEqAttribute(rowElements, 'eqPart', groupKey);

          minHeight += eqPartGroupElements[0].clientHeight;
        });

        const eqPartGroupElements = this.nodeListFilterByDataEqAttribute(rowElements, 'eqPartGroup', group);

        this.nodeListSetStyleProperty(eqPartGroupElements, 'min-height', `${minHeight}px`);

        let groupMaxHeight = 0;

        eqPartGroupElements.forEach((el) => {
          if (el.clientHeight > groupMaxHeight && el.clientHeight > minHeight) {
            groupMaxHeight = el.clientHeight;
          }
        });

        if (groupMaxHeight > 0) {
          this.nodeListSetStyleProperty(eqPartGroupElements, 'min-height', `${groupMaxHeight}px`);

          eqPartGroupElements.forEach((element) => {
            const elEqParts = this.nodeListChildren(element, '[data-eq-part]').filter((el) => groupKeys.indexOf(el.dataset.eqPart) !== -1);
            let partsHeight = 0;

            const elEqPartsFirst = elEqParts.filter((el) => el.dataset.eqPart === groupKeys[0]);
            if (elEqParts.length === groupKeys.length) {
              elEqParts.forEach((el) => {
                partsHeight += el.clientHeight;
              });

              if (partsHeight < groupMaxHeight) {
                elEqPartsFirst.forEach((el) => {
                  element.style.setProperty('min-height', `${el.clientHeight + (groupMaxHeight - partsHeight)}px`);
                });
              }
            }
          });
        }
      });
    } else {
      let minHeight = 0;
      rowElements.forEach((el) => {
        if (el.clientHeight > minHeight) {
          minHeight = el.clientHeight;
        }
      });
      this.nodeListSetStyleProperty(rowElements, 'min-height', `${minHeight}px`);
    }

    rowElements.forEach((el) => {
      el.classList.add('eq-runned');
    });
  }

  run() {
    [...document.querySelectorAll('.io-eq')].filter((el) => this.elementIsVisible(el)).forEach((eqCont) => {
      const eqElements = [...eqCont.querySelectorAll('.io-eq-el')].filter((el) => this.elementIsVisible(el));
      eqElements.forEach((eqEl) => {
        eqEl.classList.remove('eq-runned');
      });

      const eqElementsChildren = this.nodeListChildren(eqElements, '[data-eq-part]');
      if (!eqElementsChildren.length) {
        this.nodeListRemoveStyleProperty(eqElements, 'min-height');
      } else {
        this.nodeListRemoveStyleProperty(eqElementsChildren, 'min-height');
      }

      while (this.nodeListFilterByClass(eqElements, 'eq-runned').length < eqElements.length) {
        const firstOfRow = this.nodeListFilterByMissingClass(eqElements, 'eq-runned')[0];

        const rect = firstOfRow.getBoundingClientRect();
        const { top } = rect;

        const rowElements = this.getRowElements(top, eqElements);

        this.equalize(rowElements);
      }
    });
  }
}

export default Equalize;
